import AspApi from 'api/ApiConfig';

// Products API
export const getProducts = async (brandId, filters = {}, search) => {
  const response = await AspApi.get(`/api/v1/products?brand_id=${brandId}`, {
    params: { ...filters, search },
  });
  return response;
};

export const getSingleProduct = async (id, brandId) => {
  const response = await AspApi.get(
    `/api/v1/products/${id}?brand_id=${brandId}`,
  );
  return response;
};

export const createProduct = async (productData, brandId) => {
  const response = await AspApi.post(
    `/api/v1/products?brand_id=${brandId}`,
    productData,
  );
  return response;
};

export const updateProduct = async (id, productData, brandId) => {
  const response = await AspApi.put(
    `/api/v1/products/${id}?brand_id=${brandId}`,
    productData,
  );
  return response;
};

export const deleteProduct = async (id, brandId) => {
  const response = await AspApi.delete(
    `/api/v1/products/${id}?brand_id=${brandId}`,
  );
  return response;
};

// Orders API
export const getOrders = async (filters = {}, brandId) => {
  const response = await AspApi.get(
    `/api/v1/svc/transaction/payment_transaction`,
    { params: { brand_id: brandId, ...filters } },
  );
  return response;
};

/**
 * Fetches payment transactions for a specific product
 * @param {string} productId - The ID of the product
 * @param {string|number} brandId - The ID of the brand
 * @param {Object} [filters={}] - Additional filters for the query
 * @returns {Promise<Object>} Response containing payment transactions data
 */
export const getProductPaymentTransactions = async (
  productId,
  brandId,
  filters = {},
) => {
  const response = await AspApi.get(
    `/api/v1/products/${productId}/payment_transaction_list`,
    { params: { brand_id: brandId, ...filters } },
  );
  return response;
};

export const getSingleOrder = async (id, brandId) => {
  const response = await AspApi.get(
    `/api/v1/svc/transaction/payment_transaction/${id}?brand_id=${brandId}`,
  );
  return response;
};

export const updateOrderStatus = async (id, status, brandId) => {
  const response = await AspApi.patch(
    `/api/v1/svc/transaction/payment_transaction/${id}/status`,
    { status },
    {
      params: { brand_id: brandId },
    },
  );
  return response;
};
